import { Component, type ErrorInfo, type ReactNode } from 'react';

interface IPersonalFinanceErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface IPersonalFinanceErrorBoundaryState {
  hasError: boolean;
}

// React still requires a class lifecycle to catch descendant render errors.
export default class PersonalFinanceErrorBoundary extends Component<
  IPersonalFinanceErrorBoundaryProps,
  IPersonalFinanceErrorBoundaryState
> {
  override state: IPersonalFinanceErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): IPersonalFinanceErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (typeof window !== 'undefined' && window.FS) {
      window.FS('trackEvent', {
        name: 'pfc-failure',
        properties: {
          type: 'failed to render the pfc',
          error,
          errorInfo,
        },
      });
    }
  }

  override render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
